/* eslint-disable import/no-anonymous-default-export */
export default [
  {
    name: "ETH 2.0",
    info: "Deposit Contract",
    chainId: 1,
    address: "0x00000000219ab540356cBB839Cbe05303d7705Fa",
  },
  {
    name: "MSOW",
    info: "on Sourcify",
    chainId: 1,
    address: "0x07880D44b0f7b75464ad18fc2b980049c40A8bc3",
  },
  {
    name: "Uniswap",
    info: "no metadata hash",
    chainId: 1,
    address: "0xe592427a0aece92de3edee1f18e0157c05861564",
  },
  {
    name: "PODK",
    info: "metadata on ipfs",
    chainId: 1,
    address: "0x2f55dac1c137f3ee8c8513858f161671ddddf214",
  },
  {
    name: "CollateralShort",
    info: "Experimental Flag",
    chainId: 1,
    address: "0x1F2c3a1046c32729862fcB038369696e3273a516",
  },
  {
    name: "SushiSwap LP",
    info: "Polygon",
    chainId: 137,
    address: "0x2110c882c446357Ac38e36Cae03DF1578EB390b2",
  },
  {
    name: "BUSD",
    info: "BinanceSC, with bzzr1",
    chainId: 56,
    address: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
  },
  {
    name: "Wonderland DAO",
    info: "Avalanche, with bzzr0",
    chainId: 43114,
    address: "0x78a9e536EBdA08b5b9EDbE5785C9D1D50fA3278C",
  },
  {
    name: "some-old-contract",
    info: "without appended CBOR (will fail)",
    chainId: 1,
    address: "0x9af09991ad63814e53ffc1bccf213ee74027608b",
  },
];
